var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"language-json",attrs:{"tabindex":"0"}},[_vm._v("  "),(!_vm.isReload)?_c('code',{staticClass:"language-json"},[_vm._v(_vm._s(_vm.jsoncode))]):_vm._e(),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }